var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path10, _rect3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWelcome(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "welcome_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".welcome_svg__cls-1{fill:#fd934f}.welcome_svg__cls-12,.welcome_svg__cls-2,.welcome_svg__cls-5,.welcome_svg__cls-9{fill:none;stroke-linecap:round;stroke-linejoin:round}.welcome_svg__cls-2{stroke:#fa505e}.welcome_svg__cls-2,.welcome_svg__cls-5{stroke-width:16px}.welcome_svg__cls-3{fill:#2a848e}.welcome_svg__cls-4{fill:#fff}.welcome_svg__cls-5{stroke:#006c78}.welcome_svg__cls-12,.welcome_svg__cls-9{stroke:#024447}.welcome_svg__cls-9{stroke-width:24px}.welcome_svg__cls-10{isolation:isolate}.welcome_svg__cls-11{fill:#024447}.welcome_svg__cls-12{stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-1",
    d: "M592.28 917.58H492.16a32.328 32.328 0 01-32.31-32.31v-21.02a11.297 11.297 0 0111.29-11.29h121.14a32.328 32.328 0 0132.31 32.31 32.328 32.328 0 01-32.31 32.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-2",
    d: "M458.86 853.24l1 32.02a32.406 32.406 0 0032.31 32.31h100.12a32.406 32.406 0 0032.31-32.31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-1",
    d: "M247.71 852.95h121.14a11.297 11.297 0 0111.29 11.29v21.02a32.328 32.328 0 01-32.31 32.31H247.71a32.328 32.328 0 01-32.31-32.31 32.328 32.328 0 0132.31-32.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-2",
    d: "M379.14 853.24l1 32.02a32.406 32.406 0 01-32.31 32.31H247.71a32.406 32.406 0 01-32.31-32.31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-3",
    d: "M648.77 423.59v321.65a120.003 120.003 0 01-110 119.58c-3.29.28-6.63.42-10 .42H311.24c-3.37 0-6.71-.14-10-.42a119.995 119.995 0 01-110-119.58V423.59c0-126.34 102.42-228.76 228.76-228.76a228.77 228.77 0 01228.77 228.76z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-4",
    d: "M538.77 749.64V597.87c0-65.53-52.53-119.69-118.06-120.07a118.886 118.886 0 00-119.47 118.76v153.08a75.603 75.603 0 0075.6 75.6h86.33a75.603 75.603 0 0075.6-75.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-3",
    d: "M537.664 150.211a31.436 31.436 0 010 44.435l-66.065 66.065a31.436 31.436 0 01-44.435 0l-22.217-22.217 88.275-88.276a31.436 31.436 0 0144.435 0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-5",
    d: "M300.89 309.82a54.913 54.913 0 0138.9-16.18 54.93 54.93 0 0138.9 16.18M461.31 309.82a54.913 54.913 0 0138.9-16.18 54.93 54.93 0 0138.9 16.18"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "welcome_svg__cls-4",
    x: 280.33,
    y: 354.99,
    width: 118.93,
    height: 168.19,
    rx: 59.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "welcome_svg__cls-4",
    x: 440.75,
    y: 354.99,
    width: 118.93,
    height: 168.19,
    rx: 59.46
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-3",
    d: "M481.14 131.59a31.436 31.436 0 010 44.434l-66.065 66.065a31.436 31.436 0 01-44.434 0l-22.218-22.217 88.275-88.276a31.436 31.436 0 0144.435 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-5",
    d: "M436.71 131.59a31.506 31.506 0 0144.43 0 31.506 31.506 0 010 44.43l-50.92 50.92"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 588.71,
    width: 669,
    height: 237.81,
    rx: 20,
    fill: "#cae0e3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-3",
    d: "M202.67 620.01l17.3-29.97c15.4-26.67-3.85-60-34.64-60h-34.61c-30.79 0-50.04 33.33-34.64 60l17.3 29.97c15.4 26.67 53.89 26.67 69.28 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-5",
    d: "M116.08 590.04l8.65 14.99 8.65 14.99a39.998 39.998 0 0069.28 0l8.65-14.99 8.65-14.99"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-3",
    d: "M637.33 620.01l-17.3-29.97c-15.4-26.67 3.85-60 34.64-60h34.61c30.79 0 50.04 33.33 34.64 60l-17.3 29.97c-15.4 26.67-53.89 26.67-69.28 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-5",
    d: "M723.92 590.04l-8.65 14.99-8.65 14.99a39.998 39.998 0 01-69.28 0l-8.65-14.99-8.65-14.99"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-1",
    d: "M420.19 568.69a54.46 54.46 0 01-54.3-54.3v-17.72a28.53 28.53 0 0128.45-28.45h51.71a28.53 28.53 0 0128.45 28.45v17.72a54.46 54.46 0 01-54.3 54.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M420.19 548.69a34.343 34.343 0 01-34.3-34.3v-17.72a8.564 8.564 0 018.45-8.45h51.71a8.564 8.564 0 018.45 8.45v17.72a34.343 34.343 0 01-34.3 34.3z",
    fill: "#fa505e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M388.56 466.87h62.88a25.66 25.66 0 0125.66 25.66 25.66 25.66 0 01-25.66 25.66h-62.88a25.66 25.66 0 01-25.66-25.66 25.66 25.66 0 0125.66-25.66z",
    fill: "#fed425"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-9",
    d: "M307.18 443.79c8.35-6.76 19.87-10.94 32.61-10.94s24.26 4.18 32.61 10.94M467.6 443.79c8.35-6.76 19.87-10.94 32.61-10.94s24.26 4.18 32.61 10.94"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M142.714 667l10.959 47.529 2.387 13.229 2.394-12.957L167.828 667h18.3l9.863 47.523 2.526 13.235 2.562-12.72L212.144 667h17.658l-23.35 83h-16.607l-10.023-48.539-2.928-16.048-2.928 16.048L163.943 750h-16.107L124.3 667z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M142.714 667l10.959 47.529 2.387 13.229 2.394-12.957L167.828 667h18.3l9.863 47.523 2.526 13.235 2.562-12.72L212.144 667h17.658l-23.35 83h-16.607l-10.023-48.539-2.928-16.048-2.928 16.048L163.943 750h-16.107L124.3 667z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M299 682h-44v18h40v14h-40v21h46v16h-62v-84h60z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M299 682h-44v18h40v14h-40v21h46v16h-62v-84h60z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M313 667h17v68h42v15h-59z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M313 667h17v68h42v15h-59z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M388.016 676.083q9.996-10.217 25.434-10.216 20.658 0 30.21 13.696A29.855 29.855 0 01449.326 695h-17.289a23.569 23.569 0 00-4.235-8.981q-4.62-5.39-13.692-5.39a16.874 16.874 0 00-14.573 7.606q-5.334 7.607-5.334 21.528 0 13.922 5.628 20.852a17.637 17.637 0 0014.304 6.934q8.894 0 13.562-5.95 2.582-3.2 4.284-9.599h17.177q-2.223 13.527-11.357 22.004-9.137 8.475-23.407 8.476-17.66 0-27.767-11.45-10.106-11.507-10.106-31.548 0-21.668 11.496-33.399z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M388.016 676.083q9.996-10.217 25.434-10.216 20.658 0 30.21 13.696A29.855 29.855 0 01449.326 695h-17.289a23.569 23.569 0 00-4.235-8.981q-4.62-5.39-13.692-5.39a16.874 16.874 0 00-14.573 7.606q-5.334 7.607-5.334 21.528 0 13.922 5.628 20.852a17.637 17.637 0 0014.304 6.934q8.894 0 13.562-5.95 2.582-3.2 4.284-9.599h17.177q-2.223 13.527-11.357 22.004-9.137 8.475-23.407 8.476-17.66 0-27.767-11.45-10.106-11.507-10.106-31.548 0-21.668 11.496-33.399z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M524.843 743.31q-9.46 9.742-27.358 9.743-17.899 0-27.357-9.742-12.689-11.95-12.688-34.438 0-22.94 12.688-34.437 9.458-9.742 27.357-9.743 17.898 0 27.358 9.743 12.63 11.499 12.63 34.437 0 22.485-12.63 34.438zm-10.904-12.687q6.088-7.646 6.09-21.75 0-14.048-6.09-21.723-6.089-7.672-16.454-7.673-10.365 0-16.539 7.646-6.174 7.647-6.174 21.75 0 14.104 6.174 21.75 6.173 7.647 16.54 7.647 10.365 0 16.453-7.647z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M524.843 743.31q-9.46 9.742-27.358 9.743-17.899 0-27.357-9.742-12.689-11.95-12.688-34.438 0-22.94 12.688-34.437 9.458-9.742 27.357-9.743 17.898 0 27.358 9.743 12.63 11.499 12.63 34.437 0 22.485-12.63 34.438zm-10.904-12.687q6.088-7.646 6.09-21.75 0-14.048-6.09-21.723-6.089-7.672-16.454-7.673-10.365 0-16.539 7.646-6.174 7.647-6.174 21.75 0 14.104 6.174 21.75 6.173 7.647 16.54 7.647 10.365 0 16.453-7.647z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M603.79 667H630v83h-16v-56.14q0-2.42.056-6.787.055-4.363.055-6.728L598.54 750h-18.19l-15.46-69.655q0 2.365.055 6.728.055 4.366.056 6.787V750h-16v-83h24.986l14.958 65.263z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M603.79 667H630v83h-16v-56.14q0-2.42.056-6.787.055-4.363.055-6.728L598.54 750h-18.19l-15.46-69.655q0 2.365.055 6.728.055 4.366.056 6.787V750h-16v-83h24.986l14.958 65.263z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-11",
    d: "M705 682h-43v18h40v14h-40v21h45v16h-62v-84h60z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "welcome_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "welcome_svg__cls-12",
    d: "M705 682h-43v18h40v14h-40v21h45v16h-62v-84h60z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default ForwardRef;